export const isCustomDomain = (): boolean => {
  if (typeof window === 'undefined') return false
  return window.location.origin !== process.env.SYSTEME_IO_HOST
}
